import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { getReadableNumber } from "../../../utils/numberUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: "Shares outstanding",
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        display: true,
        autoSkip: false,
        callback: function (value, index, array) {
          return getReadableNumber(value);
        },
      },
    },
  },
};

const SharesOutstanding = ({ data }) => {
  let SharesOutstandingData = [];
  let SharesOutstandingDate = [];
  data?.forEach((element) => {
    SharesOutstandingData.push(element?.wabsoSplitAdjusted);
    SharesOutstandingDate.push(element?.periodEndDate);
  });

  const labels = SharesOutstandingDate?.reverse();

  const chartData = {
    labels,
    datasets: [
      {
        label: "Dataset 1",
        data: SharesOutstandingData?.reverse(),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  return (
    <div>
      <Bar options={options} data={chartData} />
    </div>
  );
};

export default SharesOutstanding;
